import Page from "components/base/Page";
import OdooFieldsPanel from "./OdooModelFieldsPanel";
import OdooModelQueryPanel from "./OdooModelQueryPanel";
import OdooSitesPanel from "./OdooSitesPanel";

const TestOdoo = () => {
  return (
    <Page title={"Test Odoo Dashboard"} childrenClassName="p-6" backTo="./..">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <OdooModelQueryPanel />
        <div className="space-y-6">
          <OdooFieldsPanel />
          <OdooSitesPanel />
        </div>
      </div>
    </Page>
  );
};

export default TestOdoo;
